module.exports = __webpack_public_path__ + "img/approve-list6.9fd28f33.png";